<!-- Payment Error Modal -->
<div class="modal fade center-modal-specific" bsModal #errorProcessingStripe="bs-modal"
    [config]="{keyboard: false, backdrop: 'static'}" id="transactionErrorModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 420px;">
        <div class="modal-content border-0 bg-pure-white overflow-hidden" style="border-radius: 6px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);">

            <!-- Header bar -->
            <div class="d-flex align-items-center justify-content-between px-4 py-3" style="border-bottom: 1px solid #e5e7eb;">
                <div class="d-flex align-items-center" style="gap: 8px;">
                    <lucide-icon name="credit-card" [size]="16" [strokeWidth]="2" class="no-fill text-gray-500"></lucide-icon>
                    <span class="f-size-14 font-weight-medium text-gray-700">Subscription billing</span>
                </div>
                <button class="btn p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100" style="border-radius: 4px; line-height: 1;"
                    (click)="close()">
                    <lucide-icon name="x" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                </button>
            </div>

            <!-- Body -->
            <div class="d-flex flex-column align-items-center text-center" style="padding: 32px 32px 24px 32px; gap: 16px;">
                <span class="f-size-48 leading-none select-none" role="img" aria-label="Error">😢</span>
                <div>
                    <h2 class="text-gray-900 mb-2" style="font-size: 16px; font-weight: 600;">There was a problem processing your payment</h2>
                    <p class="f-size-14 text-gray-500 mb-0" style="line-height: 1.6; max-width: 300px; margin: 0 auto;">
                        We couldn't charge the card on file for your Trovve subscription. Please retry or update your payment details to keep your workspace active.
                    </p>
                </div>

                <!-- Card info badge -->
                <div class="w-100 d-flex align-items-center f-size-14 text-gray-600" style="gap: 8px; padding: 8px 12px; background: #f3f4f6; border: 1px solid #e5e7eb; border-radius: 4px;">
                    <lucide-icon name="credit-card" [size]="16" [strokeWidth]="2" class="no-fill text-gray-400 flex-shrink-0"></lucide-icon>
                    <span>Card ending in <strong class="text-gray-800">&bull;&bull;&bull;&bull; {{cardLast4 || '****'}}</strong></span>
                    <span class="ml-auto f-size-12 font-weight-medium" style="padding: 2px 6px; background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; border-radius: 4px;">Declined</span>
                </div>
            </div>

            <!-- Footer -->
            <div class="d-flex align-items-center justify-content-end" style="gap: 12px; padding: 16px 20px; border-top: 1px solid #e5e7eb;">
                <button class="btn f-size-14 text-gray-600 hover:bg-gray-100 px-4 py-2" style="border-radius: 4px;"
                    [disabled]="busyLoad"
                    (click)="retrySubscription()">
                    <span *ngIf="!busyLoad">Retry</span>
                    <span *ngIf="busyLoad">Retrying...</span>
                </button>
                <button class="btn f-size-14 text-white px-4 py-2" style="background: #111827; border-radius: 4px;"
                    [disabled]="busyLoad"
                    (click)="updateCard()">
                    Update card
                </button>
            </div>

        </div>
    </div>
</div>
